import { connect } from 'react-redux';

import { registrationActions } from 'dataflow/distributorPortal/actions';

import ClientRegistrationPresentation from './ClientRegistrationPresentation';

function mapStateToProps(state) {
    const { 
        getClientList_requesting, getClientList_status,
        clientList, clientListHeader,

        addClient_requesting, addClient_status,
        updateClient_requesting, updateClient_status,
        deleteClient_requesting, deleteClient_status,
    } = state.distributorPortal_registrationReducers;

	return {
        getClientList_requesting, getClientList_status,
        clientList, clientListHeader,

        addClient_requesting, addClient_status,
        updateClient_requesting, updateClient_status,
        deleteClient_requesting, deleteClient_status,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getClientList: (pageNo, pageSize, sort, filterOptions) => { dispatch(registrationActions.getClientList(pageNo, pageSize, sort, filterOptions)); },

        addClient: (clientInfo) => { dispatch(registrationActions.addClient(clientInfo)); },
        updateClient: (clientInfo) => { dispatch(registrationActions.updateClient(clientInfo)); },
        deleteClient: (clients) => { dispatch(registrationActions.deleteClient(clients)); },
    };
}

const ClientRegistration = connect(mapStateToProps, mapDispatchToProps)(ClientRegistrationPresentation);

export default ClientRegistration;